var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"de-profile-avatar"},[_c('div',{staticClass:"de-profile-avatar__avatar-container"},[_c('ProfileAvatar',{staticClass:"de-profile-avatar__user-avatar",attrs:{"image":_vm.image,"name":_vm.name,"size":_vm.size}}),_c('DELogoBadge',{staticClass:"de-profile-avatar__logo-badge",attrs:{"badge":"","large":_vm.size === 'l'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }